import Blogs from "./components/Blogs/Blogs";
import React from "react";
import NavbarInternal from "./pages/admin/navbar/NavbarInternal";
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import {
	Route,
	Routes,
} from "react-router-dom";
import styled from "styled-components";
import { About } from "./components/About/About";
import { Program } from "./components/Program/Program";
import { Membership } from "./components/Membership/Membership";
import BlogsContent from "./components/Blogs/BlogsContent";
import Workshop from "./components/Workshop/Workshop";
import Events from "./components/Events/Events";
import { Application_membership } from "./components/Membership/Application_membership";
import { Profile } from "./components/Profile/Profile";
import EventsDetails from "./components/EventsDetails/EventsDetails";
// import Blog3 from "./components/Blogs/AllBlogs/Blog3";
import ForgotPassword from "./components/ForgotPassword/ForgotPassword";
import ResetPW from "./components/ForgotPassword/Reset-password";
import DesignThinking from "./components/EventsDetails/DesignThinking/DesignThinking";
import { Footer } from "./components/Footer/Footer";
import { WorkshopDetail } from "./components/Workshop/WorkshopDetail";
import { WorkshopDetail2 } from "./components/Workshop/WorkshopDetail2";
import { WorkshopDetail3 } from "./components/Workshop/WorkshopDetail3";
// import { WorkshopDetail4 } from "./components/Workshop/WorkshopDetail4";
// import { WorkshopDetail5 } from "./components/Workshop/WorkshopDetail5";
import { Contest } from "./components/Contest/Contest";
import { ContestDetail } from "./components/Contest/ContestDetail";
import { Mentorship } from "./components/Mentorship/Mentorship";

import Blog1 from "./components/Blogs/AllBlogs/Blog1";
import Blog2 from "./components/Blogs/AllBlogs/Blog2";
import Blog3 from "./components/Blogs/AllBlogs/Blog3";
import Blog4 from "./components/Blogs/AllBlogs/Blog4";
import Blog5 from "./components/Blogs/AllBlogs/Blog5";
import Blog6 from "./components/Blogs/AllBlogs/Blog6";
import Blog7 from "./components/Blogs/AllBlogs/Blog7";
import { Error } from "./components/Error/Error";
import OtpVerification from "./components/Membership/OtpVerification";
import EntrepreneursReunion from "./components/EventDetail/EntrepreneursReunion";
import EntrepreneurialFestival from "./components/EventDetail/EntrepreneurialFestival";
import ScrollToTop from "./components/ScrollToTop";
import Career from "./components/Career/Career";
import useAuthentication from "./services/authentication/AuthenticationService";
import Login from "./components/login/login";
import Dashboard from "./pages/admin/dashboard/Dashboard";

function App() {
	const { isAuthenticated } = useAuthentication();
	// const location = useLocation();
	console.log(isAuthenticated, "authentication");
	return (
			<div className="page-container">
				<div className="wrap">

					<ScrollToTop>
						{/* <NavbarInternal /> */}
						{/* <Routes>
							<Route path="/" exact element={<Dashboard />} />
						</Routes> */}
						<Navbar />
						<Routes>
							<Route path="/" exact element={<Home />} />
							<Route path="/contest" element={<Contest />} />
							<Route path="/blog" element={<Blogs />} />
							<Route path="/workshop" element={<Workshop />} />
							<Route path="/event" element={<Events />} />
							<Route path="/mentor" element={<Mentorship />} />
							<Route path="/about" element={<About />} />
							<Route path="program" element={<Program />} />
							<Route
								path="/membership"
								element={<Membership />}
							></Route>
							<Route
								path="/appMember"
								element={<Application_membership />}
							/>
							<Route
								path="/workshopDetail"
								element={<WorkshopDetail />}
							/>
							<Route
								path="/workshopDetail2"
								element={<WorkshopDetail2 />}
							/>
							<Route
								path="/workshopDetail3"
								element={<WorkshopDetail3 />}
							/>
							{/* <Route
								path="/workshopDetail4"
								element={<WorkshopDetail4 />}
							/>
							<Route
								path="/workshopDetail5"
								element={<WorkshopDetail5 />}
							/> */}
							<Route
								path="/appMember/profile"
								element={<Profile />}
							/>
							<Route path="/login" element={<Login />} />
							<Route
								path="/eventsdetails"
								element={<EventsDetails />}
							/>
							<Route
								path="/forgotpassword"
								element={<ForgotPassword />}
							/>
							<Route path="/Reset-password" element={<ResetPW />} />
							<Route
								path="/design-thinking"
								element={<DesignThinking />}
							/>

							<Route
								path="/A-GUIDE-TO-CREATING-AN-EFFECTIVE-IDEA-AND-BUSINESS-PLAN"
								element={<Blog1 />}
							/>
							<Route
								path="/HOW-TO-START-A-BUSINESS-WITH-LOW-INVESTMENT"
								element={<Blog2 />}
							/>
							<Route
								path="WHY-ARE-AUDIENCE-GETTING-ADDICTED-TO-LACUNA-MART-NOWADAYS"
								element={<Blog3 />}
							/>
							<Route
								path="THE-COMPLETE-BEGINNERS-GUIDE-TO-ENTREPRENEURS-STARTUP-GUIDES-FOR-ENTREPRENEURS"
								element={<Blog4 />}
							/>
							<Route
								path="WHERE-DOES-NEPAL-STAND-ON-INNOVATIVE-STARTUPS"
								element={<Blog5 />}
							/>
							<Route
								path="STARTUPS-FAILING-BUSINESSES-AND-THE-TOUGHEST-DECISIONS"
								element={<Blog6 />}
							/>
							<Route
								path="WHY-DO-STARTUPS-IN-NEPAL-FAIL"
								element={<Blog7 />}
							/>
							<Route path="/career" element={<Career />} />
							<Route
								path="/er"
								element={<EntrepreneursReunion />}
							/>
							<Route
								path="contestDetail"
								element={<ContestDetail />}
							/>
							<Route
								path="/entrepreneurs-festival"
								element={<EntrepreneurialFestival />}
							/>

							<Route
								path="A-GUIDE-TO-CREATING-AN-EFFECTIVE-IDEA-AND-BUSINESS-PLAN"
								element={<Blog1 />}
							/>
							<Route
								path="HOW-TO-START-A-BUSINESS-WITH-LOW-INVESTMENT"
								element={<Blog2 />}
							/>
							<Route
								path="WHY-ARE-AUDIENCE-GETTING-ADDICTED-TO-LACUNA-MART-NOWADAYS"
								element={<Blog3 />}
							/>
							<Route
								path="THE-COMPLETE-BEGINNERS-GUIDE-TO-ENTREPRENEURS-STARTUP-GUIDES-FOR-ENTREPRENEURS"
								element={<Blog4 />}
							/>
							<Route
								path="WHERE-DOES-NEPAL-STAND-ON-INNOVATIVE-STARTUPS"
								element={<Blog5 />}
							/>
							<Route
								path="STARTUPS-FAILING-BUSINESSES-AND-THE-TOUGHEST-DECISIONS"
								element={<Blog6 />}
							/>
							<Route
								path="WHY-DO-STARTUPS-IN-NEPAL-FAIL"
								element={<Blog7 />}
							/>
							<Route
								path="/otpVerification"
								element={<OtpVerification />}
							/>
						</Routes>
						<Footer/>
					</ScrollToTop>
				</div>
				{/* <Footer /> */}
			</div>
	);
}

export default App;
const Nav = styled.div`
	background-color: black;
	padding: 25px;
	a {
		margin-left: 20px;
		color: white;
		text-decoration: none;
		&:hover {
			color: #fa7525;
		}
	}
`;